import { cx } from '@linaria/core';
import { borderRounded } from 'styles/utils';
import { CSSProperties } from 'react';
import { iconWrapper } from './TextIcon_styles';

export interface TextIconProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  background?: string;
  size?: number;
}

export const TextIcon: import('react').FC<TextIconProps> = (props) => {
  const { text, background, style, className, size: pxSize, ...rest } = props;

  // Only Apply size props if size is provided.
  // This condition is added for backward compatibility with older components created before size prop was introduced
  const sizeProps: CSSProperties = pxSize
    ? {
        width: pxSize,
        height: pxSize,
        fontWeight: 600,
        // font size should be half of the size prop, or 16px whichever is smaller
        fontSize: Math.min(pxSize / 2, 16),
      }
    : {};

  const styleProps: CSSProperties = {
    ...(background && { backgroundColor: background }),
    ...sizeProps,
    ...style,
  };

  return (
    <div {...rest} className={cx(iconWrapper, borderRounded, className)} style={styleProps}>
      {text}
    </div>
  );
};
